import React from 'react';
import {GlobalContext} from "../../GlobalContext";
import {Badge, Card, Col, Form, Row, Table} from "react-bootstrap";
import {Glyph} from "../common/Glyph";
import moment from "moment-timezone";
import Cookies from "universal-cookie";

export class PendingLiensList extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            listTitle: "Loading Liens List...",
            liens: [],
            selectedCaseType: this.caseType.ALL
        };
    }

    caseType = {
        ALL: 'ALL',
        LIEN: 'LIEN',
        WC: 'WC'
    };

    timer = null;

    componentDidMount() {
        const cookies = new Cookies();
        let type = cookies.get("lienPendingCaseType");
        if (type) {
            this.setState({selectedCaseType: type});
        }
        this.loadList();
    }

    componentWillUnmount() {
        if (this.timer) clearTimeout(this.timer);
    }

    loadList = () => {
        if (this.context.authenticated) {
            this.context.apiRequest("GET", '/liens/pending-list', null, true)
                .then(d => {
                    if (d && d.data) {
                        this.setState({liens: d.data, listTitle: "Awaiting Approval"})
                    }
                })
                .finally(() => {
                    this.timer = setTimeout(this.loadList, 10000);
                });
        }
    }

    caseTypeSelected = (e) => {
        this.setState({selectedCaseType: e.target.value});
        const cookies = new Cookies();
        cookies.set("lienPendingCaseType", e.target.value, {path: "/"});
    }

    rowClicked = (lc) => {
        if (lc.caseType === this.caseType.WC) {
            this.props.patientSelected(lc.patientId, null, lc.referralId);
        } else {
            this.props.patientSelected(lc.patientId, lc.caseId);
        }
    }

    render() {
        let cases = this.state.liens.filter(lc =>
            this.state.selectedCaseType === this.caseType.ALL || lc.caseType === this.state.selectedCaseType);

        return (
            <Card className={this.props.className}>
                <Card.Header as={Row}>
                    <Col sm={4}>
                        {this.state.listTitle}
                    </Col>
                    <Col sm={8} className={"text-right"}>
                        <Form.Check inline label="All" name="pendingCaseType" type={'radio'}
                                    value={this.caseType.ALL}
                                    checked={this.state.selectedCaseType === this.caseType.ALL}
                                    onChange={this.caseTypeSelected}/>
                        <Form.Check inline label="Lien" name="pendingCaseType" type={'radio'}
                                    value={this.caseType.LIEN}
                                    checked={this.state.selectedCaseType === this.caseType.LIEN}
                                    onChange={this.caseTypeSelected}/>
                        <Form.Check inline label="WC" name="pendingCaseType" type={'radio'}
                                    value={this.caseType.WC}
                                    checked={this.state.selectedCaseType === this.caseType.WC}
                                    onChange={this.caseTypeSelected}/>
                    </Col>
                </Card.Header>
                <Card.Body>
                    <Table size={"sm"} hover>
                        <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th className={"small"}><strong>Patient</strong></th>
                            <th className={"small"}><strong>Attorney</strong></th>
                            <th>&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        {cases.map(lc => {
                            let days = moment.duration(moment().diff(moment(lc.created))).as('days');
                            let isWc = lc.caseType === this.caseType.WC;
                            return <tr key={`${lc.caseType}-${lc.caseId || lc.wcDataSheetId}`} className={"clickable"} onClick={e => this.rowClicked(lc)}>
                                <td>{
                                    days > 7 && <Glyph name={"circle-fill"} className={days > 14 ? "text-danger": "text-warning"}/>
                                }</td>
                                <td>{lc.ptFirst} {lc.ptLast}</td>
                                <td>{lc.linkedAttorneyGroupName || lc.lienAttorneyName || (lc.linkedAttorneyFirst ? `${lc.linkedAttorneyFirst} ${lc.linkedAttorneyLast}` : 'None')}</td>
                                <td className={"text-right"}>
                                    <Badge pill variant={isWc ? "info" : "secondary"}>{isWc ? 'WC' : 'Lien'}</Badge>
                                </td>
                            </tr>
                        })}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        );
    }
}